import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { POINT_PAGE_NAME } from '../../constants/service/app/pointConstants';
import PointListContainer from '../../containers/point/PointListContainer';

const PointList = () => {
  return (
    <PageTemplate pageName={POINT_PAGE_NAME.POINT_LIST}>
      <PointListContainer />
    </PageTemplate>
  );
};

export default PointList;
